/* ============================================================
   Shared display atoms used across pages.
   Extracted from App.js to avoid circular import between
   App.js (parent) and leaf pages that need these primitives.
============================================================ */

export const Eyebrow = ({ children, className = "" }) => (
  <div
    className={`inline-flex items-center gap-3 text-[0.68rem] font-bold tracking-[0.26em] uppercase text-neutral-400 ${className}`}
  >
    <span className="h-px w-7 bg-[#F4D64E]" />
    {children}
  </div>
);

export const PillarAccent = ({ children }) => (
  <span className="relative inline-block">
    {children}
    <span
      aria-hidden
      className="reveal-underline absolute -bottom-1 left-0 right-0 h-[2px] md:h-[3px] bg-[#F4D64E]/70 rounded-full"
    />
  </span>
);
